import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { SignInScreen } from "../auth/AuthGate";

/**
 * "Sign in to use" that keeps the current URL: clicking swaps the CTA for the
 * real sign-in screen IN PLACE (no navigation), so after the exchange the
 * member tree resolves this exact deep link — e.g. a template detail becomes
 * the member detail — instead of dumping the user at the app root.
 */
export function SignInInPlace({ className }: { className?: string }) {
  const [open, setOpen] = useState(false);
  if (open) return <SignInScreen />;
  return (
    <button
      type="button"
      {...(className ? { className } : {})}
      onClick={() => setOpen(true)}
      style={{ cursor: "pointer" }}
    >
      <FormattedMessage id="catalog.signInToUse" />
    </button>
  );
}
